import { useState } from 'react';
import PermissionsGate from '../../../api/PermissionsGate';
import { SCOPES } from '../../../config/permissions-map';
import { Unauthorized } from '../../Global/unauthorized';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { PageTitle } from '../../../../_metronic/layout/core';
import "react-datepicker/dist/react-datepicker.css";
import "./indicadores.css";
import IndicadorVenta from "./IndicadorVenta/IndicadorVenta";
import IndicadorVentaRubros from "./IndicadorVenta/IndicadorVentaRubros";
import IndicadorComparativa from "./IndicadorVenta/IndicadorComparativa";


export default function IndicadoresVentasMensual({ title }) {

    const animatedComponents = makeAnimated();
    const [tipoReporte, setTipoReporte] = useState({
        "value": "ventaMensual",
        "label": "Venta Mensual"
    });
    let tipoReportesList = {
        "defaultId": "ventaMensual",
        "list": [{
            "value": "ventaMensual",
            "label": "Venta Mensual"
        },
        {
            "value": "ventaMensualM2",
            "label": "Venta Mensual m2"
        },
        {
            "value": "ventaMensualCerrado",
            "label": "Venta Mensual Mes Cerrado"
        }]
    };

    const getOptionValueTipoReporte = idDefault => {
        return tipoReportesList.list.filter(obj => obj.value === idDefault)
    }
    const onChangeTipoReporte = (inputValue) => {
        setTipoReporte(inputValue);
    }

    return (
        <>
            <PermissionsGate RenderError={() => <Unauthorized />} scopes={[SCOPES.DASHBOARD_MALL]} >
                <PageTitle>{title}</PageTitle>
                <div className="d-flex flex-wrap flex-stack mb-6">

                <h3 className="card-title align-items-start flex-column">
                        {tipoReporte.value === "ventaMensual" && <span className="card-label fw-bolder text-gray-800">Reporte de ventas del mes en curso</span>}
                        {tipoReporte.value === "ventaMensualM2" && <span className="card-label fw-bolder text-gray-800">Reporte de ventas por m<sup>2</sup> del mes en curso </span>}
                        {tipoReporte.value === "ventaMensualCerrado" && <span className="card-label fw-bolder text-gray-800">Reporte de ventas mensual del mes cerrado</span>}

                    </h3>
                

                    <div className="d-flex flex-wrap my-2">
                        <div className="me-4" style={{ minWidth: "200px" }}>

                            <Select
                                classNamePrefix='filter'
                                components={animatedComponents}
                                defaultValue={getOptionValueTipoReporte(tipoReportesList.defaultId)}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                options={tipoReportesList.list}
                                onChange={(onChangeTipoReporte)}
                            />
                        </div>
                    </div>

                </div>

                <div className='card card-flush'>
                    <div className='card-body pt-6'>
                        <IndicadorVenta tipoReporte={tipoReporte}></IndicadorVenta>
                    </div>

                </div>
                <IndicadorVentaRubros tipoReporte={tipoReporte}></IndicadorVentaRubros>
                <IndicadorComparativa tipoReporte={tipoReporte}></IndicadorComparativa>

            </PermissionsGate>
        </>
    )
}